import ContentLoader from 'react-content-loader'

import { Box, theme } from '@factorialco/deprecated-design-system'

const CategorySkeleton = () => (
  <ContentLoader
    viewBox="0 0 518 32"
    backgroundColor={theme.colors.grey400}
    style={{ padding: `0 ${theme.dimensions.s12}` }}
  >
    <rect x="0" y="10" rx="4" ry="4" width="106" height="12" />
  </ContentLoader>
)

const ResultSkeleton = () => (
  <ContentLoader
    viewBox="0 0 518 48"
    backgroundColor={theme.colors.grey400}
    style={{ padding: `0 ${theme.dimensions.s12}` }}
  >
    <rect x="0" y="12" rx="6" ry="6" width="24" height="24" />
    <rect x="36" y="18" rx="4" ry="4" width="482" height="12" />
  </ContentLoader>
)

const LoadingState = () => (
  <Box paddingBottom="s12">
    <CategorySkeleton />
    {[...Array(5)].map((_, i) => (
      <ResultSkeleton key={i} />
    ))}
  </Box>
)

export default LoadingState
